import { Flex } from '@lego/klik-ui';
import { useNavigate } from 'react-router-dom';
import { DeviceActionScanner, Loader } from '@/components/common';
import type { DeviceScan } from '@/components/common/QrReader';
import { useApiFetch } from '@/hooks/api';
import { useDocumentTitle } from '@/hooks/common';
import { paths } from '@/utility/global_paths';

export const DeviceActionsPage = () => {
  useDocumentTitle('Device Actions');
  return (
    <DeviceActionScanner
      instructionText="Enter the serial number or scan the EMMA QR code on your device to create a new device or view an existing device status"
      title="Scan Device"
    >
      {(scan) => <DeviceStatus scan={scan} />}
    </DeviceActionScanner>
  );
};

type DeviceStatusProps = {
  scan: DeviceScan;
};

const DeviceStatus = ({ scan }: DeviceStatusProps) => {
  const navigate = useNavigate();
  useApiFetch(`/device-actions/status?serial=${scan.serialNumber}`, async (callApi) => {
    const devices = await callApi((api) =>
      api.devices.getV5Devices({
        ...(scan.macAddresses.length > 0 && { macAddressLike: scan.macAddresses[0] }),
        serialNumberLike: scan.serialNumber,
      })
    );

    const provisioned = devices.data.devices.filter((d) => d.state === 'PROVISIONED');
    const registered = devices.data.devices.filter((d) => d.state === 'REGISTERED');

    if (devices.data.itemCount === 0) {
      const searchParams = new URLSearchParams();
      searchParams.set('register', 'true');
      searchParams.set('serial', scan.serialNumber);
      for (const macAddress of scan.macAddresses) {
        searchParams.append('macAddress', macAddress);
      }
      if (scan.model && scan.vendor) {
        searchParams.set('model', scan.model);
        searchParams.set('vendor', scan.vendor);
      }
      navigate(`${paths.devices}?${searchParams.toString()}`);
    } else if (provisioned.length > 0) {
      navigate(paths.deviceById(provisioned[0].id));
    } else if (registered.length > 0) {
      navigate(paths.deviceById(registered[0].id));
    }

    return { devicesResponse: devices.data };
  });

  return (
    <Flex alignItems="center" justifyContent="center" mt={8}>
      <Loader />
    </Flex>
  );
};
